import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_75net88q84: FaireBrandEntity = {
  token: "b_75net88q84",
  type: "brand",
  name: "Atlanta Jewelers Supply",
  avatarUrl:
    "https://cdn.faire.com/fastly/e1ebb5209bd6a17484542b0692574ee0f7075de979126db62dd57bde2348668c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f601d2a04accb2a88e2d1d7615b173cd05be36702154f3933bf7bfc98d00ffbc.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e1ebb5209bd6a17484542b0692574ee0f7075de979126db62dd57bde2348668c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f601d2a04accb2a88e2d1d7615b173cd05be36702154f3933bf7bfc98d00ffbc.jpeg",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 139,
  rating: 4.8,
  reviewCount: 23,
  isInsider: true,
  description:
    "Established in 1998 we are a family owned wholesale jewelry and supplies store. We specialize in sterling silver ranging from earrings, necklaces, pendants, hoops, chains, and more. We are dedicated to providing our clients the best quality items that they will be proud to sell to their customers. ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:59.264Z",
    importedBy: "entity-db-cli",
  },
};
